import VerificationCode from "../../components/VerificationCode"

const VerificationCodePage = () => {
  return (
    <VerificationCode />
  )
}

export default VerificationCodePage